import FieldDefinition from '../../../types/common/FieldDefinition';

const getChangeDataTypeMessage = (definition: FieldDefinition, dataType: string): string => {

    return `Field ${definition.name} has data type ${definition.type}. Are you sure you want to change it to ${dataType}?`;
};

const getRemoveMessage = (definition: FieldDefinition): string => {

    return `Are you sure you want to remove field ${definition.name}?`;
};

const findNotUniqueIndex = (name: string, definitions: FieldDefinition[], index?: number): number => {

    let set = new Set<string>();

    for (var i = 0; i < definitions.length; i++) {

        if (definitions[i].name === name) {
            return index || i;
        }

        let alternativeNames = definitions?.[i]?.alternativeNames || [];

        for (var j = 0; j < alternativeNames.length; j++) {

            if (set.has(alternativeNames[j])) {
                return j;
            }
            else {
                set.add(alternativeNames[j]);
            }
        }
    }

    return -1;
}

const findDuplicateNamesCaseSensitive = (names: string[]): string[] => {

    let result: string[] = [];

    let uniqueNames = new Set();

    names.forEach((name: string) => {
        if (uniqueNames.has(name)) {
            result.push(name);
        }
        else {
            uniqueNames.add(name);
        }
    });

    return result;
}

const findDuplicateNamesCaseInsensitive = (names: string[]): string[][] => {

    let result: string[][] = [];

    let duplicates = new Map<string, string[]>();

    names.forEach((name: string) => {

        let nameToLower = name.toLowerCase();

        let values = duplicates.get(nameToLower);

        if (values) {
            values.push(name);
        }
        else {
            duplicates.set(nameToLower, [name]);
        }
    });

    duplicates.forEach((value: string[], key: string) => {
        if (value.length > 1) {
            result.push(value);
        }
    });

    return result;
}

export { getChangeDataTypeMessage, getRemoveMessage, findNotUniqueIndex, findDuplicateNamesCaseInsensitive, findDuplicateNamesCaseSensitive };
